import {
  useCallback,
  useContext,
  useEffect,
} from 'react';
import {Context} from '../contexts/WordList';
import {fetchWords} from '../helpers/localApi';

export function useLoadWords(loadItems) {
  const [state, dispatch] = useContext(Context);
  const {orderBy, language, hasMoreItems} = state;

  const loadWords = useCallback(async () => {
    if (!hasMoreItems) return;

    try {
      const itemsFromDb = await fetchWords({language, orderBy});
      dispatch({type: 'GET_WORDS', payload: itemsFromDb || []});
    } catch (error) {
      dispatch({type: 'GET_WORDS', payload: []});
    }
  }, [hasMoreItems, language, orderBy, dispatch]);

  useEffect(() => {
    loadWords();
  }, [loadWords]);

  return {loadWords};
};
